// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullAdminRegatta,
  $Model,
  $ModelUpdateParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDoubleButton,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import {
  getRegionByRegionSeasonId,
} from 'common.helpers/dist/browser';

// Types
import type {
  $ReducerState,
} from '../../../redux';

export type $OwnProps = $Translate & {
  item: $FullAdminRegatta | $Model<'Regatta'> | $ModelUpdateParams<'Regatta'>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const RegattaSuperFieldsView = function ({
  item,
  main,
  t,
}: $Props) {
  const region = getRegionByRegionSeasonId({
    regions: main.regions,
    RegionSeasonId: item.RegionSeasonId,
  });

  return (
    <>
      <Row>
        <Col
          sm={4}
          xs={6}
        >
          <InputDoubleButton
            className={'mb-3'}
            label={t('Visibility')}
            labelFalse={t('Hidden')}
            labelTrue={t('Visible')}
            name={'Public'}
            value={item.Public}
          />
        </Col>
        <Col
          sm={4}
          xs={6}
        >
          <InputDoubleButton
            className={'mb-3'}
            label={t('Page')}
            labelFalse={t('Off')}
            labelTrue={t('Enabled')}
            name={'PageEnabled'}
            value={item.PageEnabled}
          />
        </Col>
        <Col
          sm={4}
          xs={6}
        >
          <InputDoubleButton
            className={'mb-3'}
            label={t('List')}
            labelFalse={t('Off')}
            labelTrue={t('Enabled')}
            name={'ListEnabled'}
            value={item.ListEnabled}
          />
        </Col>
        <Col
          sm={4}
          xs={6}
        >
          <InputDoubleButton
            className={'mb-3'}
            label={t('Highlight')}
            labelFalse={t('Off')}
            labelTrue={t('On')}
            name={'Highlight'}
            value={item.Highlight}
          />
        </Col>
        <Col
          sm={4}
          xs={6}
        >
          <InputDoubleButton
            className={'mb-3'}
            label={t('Lock')}
            labelFalse={t('Off')}
            labelTrue={t('Locked')}
            name={'Lock'}
            value={item.Lock}
          />
        </Col>
        <Col
          sm={4}
          xs={6}
        >
          <InputDoubleButton
            className={'mb-3'}
            label={t('Canceled')}
            labelFalse={t('Off')}
            labelTrue={t('Canceled')}
            name={'Canceled'}
            value={item.Canceled}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Region season')}
            name={'RegionSeasonId'}
            required
            type={'select'}
            value={item.RegionSeasonId}
          >
            {_.map(
              region.RegionSeasons,
              (i) => (
                <option
                  key={i.id}
                  value={i.id}
                >
                  {i.Name}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Invoice')}
            name={'Invoice'}
            value={item.Invoice}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegattaSuperFieldsView;
